export default {
  name: "o-modal-dialog",
  props: {
    id: {
      type: String,
      default: () => "modal-dialog"
    },
    title: {
      type: String,
      default: () => "Modal Dialog"
    },
    theme: {
      type: String,
      default: () => "light"
    },
    btnSave: {
      type: Object,
      default: () => {
        return {
          label: "Save",
          click: () => {}
        };
      }
    },
    btnCancel: {
      type: Object,
      default: () => {
        return {
          label: "Cancel",
          click: () => {}
        };
      }
    }
  },
  computed: {
    compTheme() {
      if (this.theme === "light") {
        return ["bg-light", "text-dark"].join(" ");
      }
      return ["bg-dark", "text-light"].join(" ");
    },
    compCloseButton() {
      return this.theme === "light" ? "" : "btn-close-white";
    }
  }
};